import { pickBy } from "lodash";
const _RicosTextStyle = class _RicosTextStyle {
  constructor(textStyle) {
    this.getTextStyle = () => this.textStyle;
    this.toCustomStyle = () => {
      return { lineHeight: this.textStyle.lineHeight };
    };
    this.overrideWith = (textStyle) => {
      return _RicosTextStyle.of({ ...this.textStyle, ...textStyle });
    };
    this.textStyle = this.preprocess(textStyle);
  }
  preprocess(textStyle) {
    let lineHeight = textStyle.lineHeight;
    if (lineHeight && !Number(lineHeight)) {
      if (lineHeight.includes("px") || lineHeight.includes("em")) {
        lineHeight = lineHeight.slice(0, lineHeight.length - 2);
      }
    }
    return pickBy({ ...textStyle, lineHeight });
  }
  static of(textStyle) {
    return new _RicosTextStyle(textStyle || {});
  }
};
_RicosTextStyle.fromCustomStyle = (customStyle) => {
  const { lineHeight } = customStyle;
  const textStyle = { lineHeight };
  return _RicosTextStyle.of(textStyle);
};
let RicosTextStyle = _RicosTextStyle;
export {
  RicosTextStyle
};
//# sourceMappingURL=text-style.js.map
